/*
 * Purpose: Home — outcome landing for anonymous / new users (P1 authed → dashboard)
 * Last modified: 2026-06-28 | Agent
 * Completeness: 95
 */
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BookOpen, LogIn, CreditCard } from 'lucide-react';
import { BrandMark } from '@/components/brand/BrandMark';
import { PRODUCT_NAME } from '@/lib/productTerms';
import { HomeOutcomeHero } from '@/components/home/HomeOutcomeHero';
import { PageMotion } from '@/components/motion/PageMotion';
import { AUTH_CONFIG } from '@/lib/auth-config';
import { APP_ROUTES } from '@/lib/appRoutes';
import { REMEDIATION } from '@/lib/remediationRoutes';
import { useAppTopOffset } from '@/hooks/use-app-top-offset';

const Index = () => {
  const navigate = useNavigate();
  const topChromeRef = useRef<HTMLDivElement>(null);
  useAppTopOffset(topChromeRef);

  return (
    <div className="min-h-screen bg-background flex flex-col ui-page-hierarchy">
      <div ref={topChromeRef} data-app-top-chrome className="sticky top-0 z-30 shrink-0 bg-background/90 backdrop-blur-sm will-change-transform">
        <header className="border-b border-border/40">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
            <div className="flex items-center gap-2 min-w-0">
              <BrandMark size={28} className="shrink-0" ghostAccent="darker" />
              <div className="min-w-0">
                <h1 className="ab-brand-wordmark text-foreground">{PRODUCT_NAME}</h1>
                <p className="ab-brand-tagline">Zapier &amp; Make alternative · Secure. Observable. Traceable.</p>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <Button
                actionTier="secondary"
                size="sm"
                onClick={() => navigate(`${AUTH_CONFIG.signInPath}?next=${encodeURIComponent(REMEDIATION.dashboard)}`)}
              >
                <LogIn className="w-4 h-4 sm:mr-1.5" />
                <span className="hidden sm:inline">Sign in</span>
              </Button>
              <Button variant="ghost" size="sm" onClick={() => navigate(APP_ROUTES.pricing)}>
                <CreditCard className="w-4 h-4 sm:mr-1.5" />
                <span className="hidden sm:inline">Pricing</span>
              </Button>
              <Button variant="ghost" size="sm" onClick={() => navigate(APP_ROUTES.help)}>
                <BookOpen className="w-4 h-4 sm:mr-1.5" />
                <span className="hidden sm:inline">Help</span>
              </Button>
            </div>
          </div>
        </header>
      </div>

      <main className="flex-1 min-h-0">
        <PageMotion variant="body">
          <HomeOutcomeHero />
        </PageMotion>
      </main>
    </div>
  );
};

export default Index;
